module.exports = __webpack_public_path__ + "images/directory/featured-hero/Jira.0611411ec3c4152035f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/Jira.jpg
// module id = h8KU
// module chunks = 0